//
//
//
//
//
//
//
//
//
//
//

import childDevice901 from './childDevice901'
import childSetWatch from './childSetWatch.vue'
export default {
  name: 'NewSubDeviceSet',
  components: {childDevice901, childSetWatch},
  data () {
    return {
      deviceObj: ''
    }
  },
  created () {
    this.deviceObj = this.$store.getters.get_child_obj
  },
  methods: {
    getFatherEvent901 () {},
    isWatch (type) {
      return [310, 311, 312, 330, 332].indexOf(type) >= 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/device/NewSubDeviceSet.vue